(function(){
  if (window.hnFarbpunkte) return; window.hnFarbpunkte = true;
  function lazyFix(root){
    root.querySelectorAll('img').forEach(function(im){
      if (im.dataset.srcset && !im.getAttribute('srcset')) im.setAttribute('srcset', im.dataset.srcset);
      if (im.dataset.src && !im.getAttribute('src')) im.setAttribute('src', im.dataset.src);
      if (im.dataset.sizes === 'auto' || !im.getAttribute('sizes')) im.setAttribute('sizes', Math.max(150, Math.round(im.closest('.card-media') ? im.closest('.card-media').offsetWidth : 300)) + 'px');
      im.classList.remove('lazyload'); im.classList.add('lazyloaded');
    });
  }
  function snapshot(item, box){
    if (box._hnOrig) return;
    var media = item.querySelector('.card-media');
    var priceEl = item.querySelector('.card-price');
    var formEl = item.querySelector('.card-action form');
    var t = item.querySelector('.card-title');
    var tpl = document.createElement('template');
    tpl.setAttribute('data-hn-fp-tpl', box.querySelector('.hn-fp__dot.is-on').getAttribute('data-hn-fp'));
    tpl.dataset.id = item.getAttribute('data-product-id');
    tpl.dataset.url = t ? t.getAttribute('href') : '';
    tpl.dataset.title = t ? (t.getAttribute('data-product-title') || t.textContent.trim()) : '';
    var w = item.querySelector('[data-wishlist-handle]');
    tpl.dataset.handle = w ? w.getAttribute('data-wishlist-handle') : '';
    var html = '<div data-part="media">';
    if (media) Array.prototype.forEach.call(media.children, function(c){ if (c.matches('img,video,svg,.data-lazy-loading')) html += c.outerHTML; });
    html += '</div><div data-part="price">' + (priceEl ? priceEl.innerHTML : '') + '</div>';
    html += '<div data-part="form">' + (formEl ? formEl.outerHTML : '') + '</div>';
    tpl.innerHTML = html;
    box.appendChild(tpl);
    box._hnOrig = true;
  }
  function apply(btn){
    var box = btn.closest('.hn-fp'); var item = box && box.parentElement ? box.parentElement.querySelector('.product-item') : null;
    if (!box || !item || btn.classList.contains('is-on')) return;
    snapshot(item, box);
    var tpl = box.querySelector('template[data-hn-fp-tpl="' + btn.getAttribute('data-hn-fp') + '"]');
    if (!tpl) return;
    var frag = tpl.content.cloneNode(true);
    var oldT = item.querySelector('.card-title'); var oldUrl = oldT ? oldT.getAttribute('href') : null;
    var d = tpl.dataset;
    /* Fotos */
    var media = item.querySelector('.card-media'); var pm = frag.querySelector('[data-part="media"]');
    if (media && pm) {
      Array.prototype.slice.call(media.children).forEach(function(c){ if (c.matches('img,video,svg,.data-lazy-loading')) c.remove(); });
      var anchor = media.querySelector('.card-link') || media.firstChild;
      var imgs = Array.prototype.slice.call(pm.children);
      imgs.forEach(function(c){ media.insertBefore(c, anchor); });
      lazyFix(media);
      media.classList.toggle('media--hover-effect', media.querySelectorAll(':scope > img').length > 1);
      media.classList.remove('hn-alt');
    }
    /* Links + Name */
    if (oldUrl) item.querySelectorAll('a[href="' + oldUrl + '"]').forEach(function(a){ a.setAttribute('href', d.url); });
    item.querySelectorAll('[data-product-url]').forEach(function(a){ a.setAttribute('data-product-url', d.url); });
    var cl = item.querySelector('.card-link'); if (cl) cl.setAttribute('title', d.title);
    if (oldT) { oldT.setAttribute('data-product-title', d.title); oldT.textContent = d.title; }
    /* Preis */
    var pr = item.querySelector('.card-price'); var pp = frag.querySelector('[data-part="price"]');
    if (pr && pp) pr.innerHTML = pp.innerHTML;
    /* Warenkorb-Knopf */
    var f = item.querySelector('.card-action form'); var pf = frag.querySelector('[data-part="form"] form');
    if (f && pf) { var fid = f.getAttribute('id'); pf.setAttribute('id', fid); pf.querySelectorAll('[data-form-id]').forEach(function(b){ b.setAttribute('data-form-id', '#' + fid); }); f.replaceWith(pf); }
    /* Merkzettel, IDs */
    item.querySelectorAll('[data-wishlist-handle]').forEach(function(w){ w.setAttribute('data-wishlist-handle', d.handle); w.setAttribute('data-product-id', d.id); });
    item.querySelectorAll('[data-product-handle]').forEach(function(w){ w.setAttribute('data-product-handle', d.handle); w.setAttribute('data-product-id', d.id); });
    item.setAttribute('data-product-id', d.id);
    box.querySelectorAll('.hn-fp__dot').forEach(function(b){ var on = b === btn; b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false'); });
  }
  document.addEventListener('click', function(e){
    var btn = e.target.closest && e.target.closest('.hn-fp__dot');
    if (!btn) return;
    e.preventDefault(); e.stopPropagation();
    apply(btn);
  }, true);
})();
